export { default } from './offer-details';
